import * as React from 'react';
import { Main } from './main';

const PreLoaderComponent = () => <Main />;

export const PreLoader = React.memo(PreLoaderComponent);
